module.exports = __webpack_public_path__ + "img/PRESENCE_GRILLE_POINTAGE.9a19f435.svg";